import { defineComponent as t, openBlock as r, createBlock as n, unref as p, mergeProps as c, withCtx as m, createElementVNode as a } from "vue";
import { RevIcon as i } from "@ds/components/Icon";
const f = /* @__PURE__ */ t({
  name: "IconRepairStore",
  __name: "IconRepairStore",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(l) {
    const o = l;
    return (d, e) => (r(), n(p(i), c(o, { "view-box": "0 0 24 24" }), {
      default: m(() => [...e[0] || (e[0] = [
        a("path", {
          "fill-rule": "evenodd",
          d: "m8.524 9.076-.95.475C6.984 9.846 6.546 10 5.886 10H4.962v7.75a.75.75 0 0 0 .75.75h8.538a.75.75 0 0 1 0 1.5H5.712a2.25 2.25 0 0 1-2.25-2.25V9.942c-.6-.19-1.202-.82-1.052-1.473L3.5 5.244A2.25 2.25 0 0 1 5.694 3.5h12.614A2.25 2.25 0 0 1 20.5 5.244l1.09 3.551c.151.654-.49 1.207-1.09 1.397V15a.75.75 0 0 1-1.5 0v-4.75L18.326 10a4.25 4.25 0 0 1-1.9-.449l-.95-.475-.015.006-1 .429a6.25 6.25 0 0 1-4.923 0l-1-.429-.014-.006m.772-1.3L9.685 5h4.63l.389 2.775-.833.357a4.75 4.75 0 0 1-3.742 0L9.296 7.775M8.18 5 7.79 7.766 6.904 8.21a2.75 2.75 0 0 1-1.23.29H3.943l1.02-2.919A.75.75 0 0 1 5.692 5H8.18m8.03 2.766.887.444a2.75 2.75 0 0 0 1.23.29h1.731l-1.02-2.919A.75.75 0 0 0 18.307 5H15.82l.388 2.766",
          "clip-rule": "evenodd"
        }, null, -1),
        a("path", { d: "M16.06 11.817c.836.837 1.082 2.263.575 3.403l5.082 5.083a1 1 0 1 1-1.414 1.414l-5.083-5.082c-1.14.507-2.566.261-3.403-.575-1.001-1.001-.939-2.358-.817-3.064.038-.22.296-.286.454-.128l1.69 1.69a.3.3 0 0 0 .212.088h.99a.3.3 0 0 0 .3-.3v-.99a.3.3 0 0 0-.088-.212l-1.69-1.69c-.158-.158-.092-.416.128-.454.706-.122 2.063-.184 3.064.817" }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  f as default
};
